<template>
  <v-row>
    <v-col cols="12" class="mt-0 mb-1 pb-0 pt-2">
      <v-dialog
        ref="time_field_dialog"
        v-model="show_dialogue"
        :return-value.sync="time"
        persistent
        width="290px"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            clearable
            class="flex-md-grow-1"
            dense
            outlined
            filled
            autocomplete="off"
            :label="label"
            :prepend-inner-icon="icon"
            :disabled="disabled"
            v-model="time"
            :rules="validation_rules"
            :required="required"
            readonly
            v-bind="attrs"
            v-on="on"
          ></v-text-field>
        </template>
        <v-time-picker v-if="show_dialogue" v-model="time" :max="max" :min="min" :format="format" full-width>
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="show_dialogue = false"> Cancel </v-btn>
          <v-btn text color="primary" @click="$refs.time_field_dialog.save(time)">
            OK
          </v-btn>
        </v-time-picker>
      </v-dialog>
    </v-col>
  </v-row>
</template>


<script>
export default {
  name: "TimeField",
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: "",
    },
    icon: {
      type: String,
      default: "mdi-clock-time-four-outline",
    },
    required: {
      type: Boolean,
      default: false,
    },
    value: {
      type: [String, Number],
      default: "",
    },
    validation_rules: {
      type: Array,
      default: () => {
        return [];
      },
    },
    max: {
      type: String,
      default: null
    },
    min: {
      type: String,
      default: null
    },
    value_format: {
      type: String,
      default: "ampm"
    },
    format: {
      type: String,
      default: "ampm"
    }
  },
  data: () => {
    return {
      show_dialogue: false,
    };
  },
  computed: {
    time: {
      get() {
        if (
          typeof this.value == "undefined" ||
          this.value == undefined ||
          this.value == null ||
          this.value.toString().trim() == "" || 
          this.value.toString().trim() == "closed"
        ) {
          return "00:00";
        }
        var get_value = this.value;
        if(this.value_format == "ampm"){
            var parts = get_value.split(":");
            var hours = parseInt(parts[0]);
            var last_part = parts[1].trim();
            var last_parts = last_part.split(" ");
            var mins = parseInt(last_parts[0]);
            var ampm = "AM";
            var new_hours = hours;
            if(last_parts.length > 1){
                ampm = last_parts[1].toUpperCase();
            }
            if(ampm == "PM"){
                new_hours = hours + 12;
            }
            new_hours = (new_hours < 10) ? ("0" + new_hours) : (new_hours+"");
            mins = (mins < 10) ? ("0"+mins) : (mins+"");
            get_value = new_hours + ":" + mins;
        }
        return get_value;
      },
      set(new_value) {
        //covert this to 12 hour clock
        var in12hrs = new_value;
        if(in12hrs){
            var parts = in12hrs.split(":");
            var hours = parseInt(parts[0]);
            var mins = parseInt(parts[1]);
            var new_hours = hours;
            var ampm = "AM";
            if(hours > 12){
                new_hours = hours - 12;
                ampm = "PM";
            }
            new_hours = (new_hours < 10) ? ("0" + new_hours) : (new_hours+"");
            mins = (mins < 10) ? ("0"+mins) : (mins+"");
            in12hrs = new_hours + ":" + mins + " " + ampm;
        }
        var set_value = new_value;
        if(this.value_format == "ampm"){
            set_value = in12hrs;
        }
        this.$emit("input", set_value);
      },
    },
  },
};
</script>

